export const version = 'v2.2.4-2064-gd46f5eb63'
